(() => {
  const update = (container) => {
    const checkbox = container.querySelector('[data-cart-terms-checkbox]');
    const scope = container.parentElement;
    const checkout = scope?.querySelector('[data-cart-terms-checkout]');
    const accelerated = scope?.querySelector('[data-cart-terms-accelerated]');
    const accepted = Boolean(checkbox?.checked);

    if (checkout) checkout.disabled = !accepted || checkout.dataset.cartEmpty === 'true';
    if (accelerated) accelerated.inert = !accepted;
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-cart-terms-container]').forEach((container) => {
      if (container.dataset.cartTermsReady === 'true') return;
      container.dataset.cartTermsReady = 'true';
      const checkbox = container.querySelector('[data-cart-terms-checkbox]');
      checkbox?.addEventListener('change', () => update(container));
      update(container);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize());

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.('[data-cart-terms-container]')) initialize(node.parentElement);
        else initialize(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
